import { FC } from "react";
import { GeneralTemplate } from "@/components/templates/GeneralTemplate";
import { SystemHeader } from "@/components/SystemHeader/SystemHeader";
import { AppVersion } from "@/components/AppVersion";
import { useTranslation } from "react-i18next";

interface SessionErrorPageProps {
  errorType: "not_login" | "forbidden";
}

export const SessionErrorPage: FC<SessionErrorPageProps> = ({ errorType }) => {
  const { t } = useTranslation();
  return (
    <GeneralTemplate
      header={
        <>
          <SystemHeader />
          <div className="flex h-12 w-full flex-row items-center border-b-[1px] border-gray-200 bg-white pl-4 pr-2">
            <p className="text-base font-normal">{t("app_title")}</p>
            <div className="h-2 flex-1" />
          </div>
        </>
      }
      loading={false}
    >
      <div className="flex w-full flex-col items-center px-6">
        <div className={"flex flex-col gap-2 py-8"}>
          <p>Error</p>
          <p className={"text-sm"}>{t(`error_${errorType}_description`)}</p>
        </div>
      </div>
      <AppVersion />
    </GeneralTemplate>
  );
};
